// ============================================================
// WsEvents.ts — Miroir EXACT de agence_api/src/websocket/WsEvents.ts
// Toute modification doit être répercutée des deux côtés
// ============================================================

export enum WsEventType {
  // ── Rapports ──────────────────────────────────────────────
  REPORT_DONE  = 'report:done',
  REPORT_ERROR = 'report:error',

  // ── Notifications in-app ──────────────────────────────────
  NOTIFICATION_NEW = 'notification:new',

  // ── Futurs événements (décommenter au besoin) ─────────────
  // DOCUMENT_VALIDATED  = 'document:validated',
  // STOCK_ALERT         = 'stock:alert',
  // NEW_COMMANDE        = 'commande:new',
  // PAIEMENT_RECU       = 'paiement:recu',
}

// Enveloppe commune à tous les événements reçus depuis le serveur
export interface WsPayload<T = any> {
  type:      WsEventType;
  payload:   T;
  timestamp: string;    // ISO 8601
  owner_id:  number;
  user_id?:  number;
}

// ── Payloads métier ───────────────────────────────────────────

export interface ReportResultPayload {
  job_id:        number;
  statut:        'DONE' | 'ERROR';
  file_path:     string | null;
  error_message: string | null;
}

/**
 * Émis quand le Worker (InAppProvider) vient d'insérer une notification.
 * Le frontend incrémente le badge et — si popup=true — affiche un toast.
 * Les détails complets sont récupérables via GET /notifications.
 */
export interface InAppNotificationPayload {
  notification_id: number;
  user_id:         number | null;     // NULL = broadcast tenant
  titre:           string;
  message:         string;
  niveau:          'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR';
  popup:           boolean;
  lien:            string | null;
}
